import React from 'react';
import { useLocation } from 'react-router-dom';
import MyLogin from '@hst/h5-my-login-react';
import { inApp } from '@hst/utils';
import { marketingApi } from 'src/api';
import { connect } from 'react-redux';
import { setUserInfo } from 'src/store/common/actions';
import { jumpPathPageByWindow, commonH5Jump, jumpTransferPage } from 'src/utils/jump';
import { useTranslation } from 'react-i18next';
import { isProd, ENV } from 'src/config/env';
import { trackActivityLoginClick } from '../../track';
import DomianInfos from 'src/config/domain';

interface propsType {
	data: {
		backgroundImg: string; // 背景图片
		backGroundColor: string; //背景颜色
		btnName?: string; // 按钮名称
		btnText?: string; // 按钮文案
		textColor?: string; // 字体颜色
		jumpLink?: number; // 跳转类型 1 下载/唤起APP 2 H5链接 3 原生链接
		jumpLinkStr?: string; // 原生跳转LINK
		jumpPosition?: string; // H5跳转链接
		jumpParam?: string; // 原生跳转参数
	};
	setUserInfo;
}
const BaseLogin = (props: propsType) => {
	const { data } = props;
	const { i18n } = useTranslation();
	const lang = i18n.language;
	const searchParams = new URLSearchParams(useLocation().search);
	const pageId = searchParams.get('id') || '';
	const _scnl = searchParams.get('_scnl') || '';

	const handleJump = () => {
		const { jumpLink, jumpPosition, jumpLinkStr, jumpParam } = data;
		switch (jumpLink) {
			case 1:
				if (!inApp()) {
					jumpTransferPage(lang, {
						redirectType: '1',
						redirectValue: { _scnl },
					});
				}
				break;
			case 2:
				jumpPathPageByWindow(jumpPosition, { _scnl });
				break;
			case 3:
				commonH5Jump(jumpLinkStr, { ...JSON.parse(jumpParam), _scnl }, lang);
				break;
			default:
				break;
		}
	};

	const successCallback = async () => {
		trackActivityLoginClick(pageId);
		try {
			const { success, data } = await marketingApi.getAccountStatus({
				buzz: { withAC: true },
			});
			if (success) {
				props.setUserInfo(data);
			}
			if ('scrollRestoration' in history) {
				history.scrollRestoration = 'manual';
			}
			window.scrollTo(0, 0);
			handleJump();
		} catch (error) {
			handleJump();
		}
	};

	return (
		<MyLogin
			lang={lang}
			options={data}
			baseUrl={isProd ? DomianInfos.baseApi : '/api'}
			env={ENV}
			loginSuccessCallback={successCallback}
			signUpSuccessCallback={successCallback}
		/>
	);
};

const mapDispatchToProps = {
	setUserInfo,
};

export default connect(null, mapDispatchToProps)(BaseLogin);
